import { useState, useEffect, useRef } from "react";

import {
  RightSlidingPanelWrapper,
  RightSlidingPanelContainer,
  SlidingPanelOverlay,
  RightSlidingPanelContent,
} from "./rightSlidingPanelStyles";

const RightSlidingPanel = (props) => {
  const { isOpen, closePanel, children, width, contentZIndex,overlayZIndex } = props;
  return (
    <RightSlidingPanelWrapper
      role="complementary"
      aria-label="right-panel"
      aria-hidden={!isOpen}
    >
      <SlidingPanelOverlay
        onClick={() => {
          closePanel();
        }}
        isOpen={isOpen}
        zIndex={overlayZIndex}
      />
      <RightSlidingPanelContainer isOpen={isOpen} width={width} zIndex={contentZIndex}>
        <RightSlidingPanelContent>{children}</RightSlidingPanelContent>
      </RightSlidingPanelContainer>
    </RightSlidingPanelWrapper>
  );
};

export default RightSlidingPanel;
